import { Panel } from 'primereact/panel';
import Card from "../../components/card/card";
import "./styles.css"

function PaginaNaoEncontrada() {
    return (
        <div className="d-flex justify-content-center mt-3">
            <Card className='d-flex row justify-content-center'>
                <h2 className='font-bold'>Not Found 404</h2>
                    <p className='text-sm mt-3'>
                    Nenhuma página foi encontrada para o endereço acessado.
                    </p>
                    <br />
                    <p className='text-sm text-indigo-600 hover:text-indigo-700 hover:underline'><a href='/'>Clique aqui para ir para página inicial</a></p>
            </Card>
        </div>
    )
}

export default PaginaNaoEncontrada;